$(document).ready(function(){

var face_look = 0;
var improve = 0;
var tried = 'yes';
var current_question = 0;
var chosen;
var score = 60;
var fname = "";
var answers;
var selected = false;
var introduction_html = $('.introduction').html();
var products = {
0: [2016495599686, 2016501170246, 2016529252422],
1: [2016633258054, 2016637681734, 2016624705606],
2: [2016633258054, 2016512737350, 2016630308934],
3: [2016633258054, 2016630308934, 2016637681734],
4: [2016495599686, 2015870484550, 2016508182598]
};

KlaviyoSubscribe.attachToForms('.email form', {
hide_form_on_success: true
});

var questions = [
{
question: "What is your age?",
options: [
{
option: "16 – 25",
value: 0
},
{
option: "26 – 35",
value: -2
},
{
option: "35 – 45",
value: -5
},
{
option: "45 – 60",
value: -8
},
{
option: "60+",
value: -10
},
]
},
{
question: "How many hours of sleep do you get a night?",
options: [
{
option: "1 - 4",
value: -5
},
{
option: "5 - 6",
value: 0
},
{
option: "7+",
value: 1
},
]
},
{
question: "How many glasses of water do you drink daily?",
options: [
{
option: "1 - 3",
value: -4
},
{
option: "4 - 5",
value: 1
},
{
option: "6 - 7",
value: 3
},
{
option: "8+",
value: 5
},
]
},
{
question: "At the end of the day, does your face look:",
options: [
{
option: "Dry or parched",
value: 0
},
{
option: "Same as when you woke up",
value: 0
},
{
option: "Oily or shiny",
value: 0
},
]
},
{
question: "What are your main eye area concerns?",
options: [
{
option: "Fine lines",
value: 0
},
{
option: "Puffiness",
value: 0
},
{
option: "Dark Circles",
value: 0
},
{
option: "Crows feet",
value: 0
},
{
option: "Prevention",
value: 0
},
]
},
{
question: "What about your skin would you most like to improve?",
options: [
{
option: "Large pores",
value: 0
},
{
option: "Tired eyes",
value: 0
},
{
option: "Fine lines and wrinkles",
value: 0
},
{
option: "Loss of elasticity",
value: 0
},
{
option: "Dullness",
value: 0
},
]
},
{
question: "Have you tried Eight Saints Skincare?",
options: [
{
option: "Yes",
value: 0
},
{
option: "No",
value: 0
},
]
},
];



if (Cookies.get("score")) {
score = Math.floor(Cookies.get("score"));
fname = Cookies.get("fname");
improve = Cookies.get("improve");
face_look = Cookies.get("face_look");
tried = Cookies.get('tried');
showResults();
$(".results").show();
$(".question, .introduction").hide();
} else {
$('.skin-quiz').addClass('started');
answers = [];
$(".back").hide();
var question = questions[current_question];
$(".question").not(".email").show();
$(".question h2").text(question.question);
loadQuestions(question);
}

$(".retake").click(function(e){
e.preventDefault();
Cookies.remove("score");
Cookies.remove("fname");
Cookies.remove("improve");
Cookies.remove("tried");
Cookies.remove("face_look");
score = 60;
answers = [];
$('.introduction').after('<div class="introduction">' + introduction_html + '</div>');
$('.introduction').first().remove();
$('html, body').animate({
scrollTop: 1
}, 200);
$(".results").hide();
current_question = 0;
$(".options").empty();
current_question = 0;
var question = questions[current_question];
$(".question").not(".email").show();
$(".question h2").text(question.question);
loadQuestions(question);

});
$(".back").click(function(){
$('.option.selected').removeClass('selected');
current_question--;
if (current_question == 0) {
$(".back").hide();
}
score -= questions[current_question].options[answers[current_question]].value;
var question = questions[current_question];
$(".question h2").text(question.question);
$(".options").empty();
loadQuestions(question);
answers.pop();
});
function showResults() {
Cookies.set("taken", 1);
if (tried == 1) {  
$('.results .results-product').hide();
//$('.products').prepend($('div.results-product[data-product-id="2043719581766"]'));
//$('div.results-product[data-product-id="2043719581766"]').show();
var suggested_products = products[improve];
//suggested_products.pop();
suggested_products.forEach((id) => {
$('.results-product[data-product-id=' + id + ']').show();
});
$('.results-hero').hide();
$('.results-hero-discovery').show();
$('.results .products').show();
$('.results .discovery_container').show();
} else {
$('.results-hero').show();
$('.results-hero-discovery').hide();
$('.results .products').show();
$('.results .discovery_container').hide();
$('.results .results-product').hide();
var suggested_products = products[improve];
suggested_products.forEach((id) => {
$('.results-product[data-product-id=' + id + ']').show();
});
}

}
function loadQuestions(question) {
for (var j = 0; j < question.options.length; j++) {
if (question.options[j].option != "") {
$(".options").append("<div class='option'><input type='radio' id='" + j + '' + current_question + "' value='" + j + "' name='" + current_question + "' /><label for='" + j + '' + current_question + "'>" + question.options[j].option + "</label></div>");
}
}
$("input[name='" + current_question + "']").change(function(){
if (!selected) {
$(this).parent().find('label').addClass('selected');	
}
selected = true;
setTimeout(function(){
console.log(current_question);

if (!isNaN(parseInt($("input[name='" + current_question + "']:checked").val()))) {
chosen = parseInt($("input[name='" + current_question + "']:checked").val());
answers.push(chosen);
$(".back").show();
if (current_question == 5) {
improve = chosen;
} else if (current_question == 6) {
tried = chosen;
}

score += questions[current_question].options[chosen].value;
current_question++;
if (current_question == questions.length) {

$(".question").hide();
$(".introduction").hide();
// $(".results").show();
if (Cookies.get("taken") != "1") {
$('html, body').animate({
scrollTop: 1
}, 200);
$(".email h2").text("What is your name and email address?");
$(".email").show();

$(".email form").submit(function(e){
if ($('#quiz_form_001 input[name=first_name]').val() == '' || $('#quiz_form_001 input[name=email]').val() == '') {
return;	
}
$('html, body').animate({
scrollTop: 1
}, 200);
$(".email").hide();
$(".results").show();
fname = $("input[name='first_name']").val();
Cookies.set("fname", fname);
Cookies.set("tried", tried);
Cookies.set("score", score);
Cookies.set("face_look", face_look);
Cookies.set("improve", improve);
showResults();

});
} else {
$(".results").show();
fname = $("input[name='first_name']").val();
Cookies.set("fname", fname);
Cookies.set("tried", tried);
Cookies.set("score", score);
Cookies.set("face_look", face_look);
Cookies.set("improve", improve);
showResults();
}

} else {
var question = questions[current_question];
$(".question h2").text(question.question);
$(".options").empty();
loadQuestions(question);
}
} 
selected = false;
}, 500);

});
}
});